window.Valence ||= {}
window.Valence.Utils ||= {}

window.Valence.Utils.Templates = {
  cloneTemplate({
    container,
    template,
    callback = () => {},
    insertBeforeTarget = undefined,
    insertMethod = 'append',
  }) {
    const clone = template.content.cloneNode(true)
    callback(clone)
    if (insertMethod === 'append') {
      container.append(clone)
    } else if (insertMethod === 'insertBefore') {
      container.insertBefore(clone, insertBeforeTarget)
    } else {
      container.prepend(clone)
    }
  },
}
